<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-buttons slot="start">
      <ion-button *ngIf="view === 'custom-price' || (view === 'scan' && isVariable) || view === 'manual' || view ==='summary'"
                  mode="md"
                  color="orange"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onBack()">
        <ion-icon name="arrow-back-outline"></ion-icon>
        Back
      </ion-button>
    </ion-buttons>
    <ion-title>Add Gift Card</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar mode="md"
               color="orange"
               *ngIf="view !== 'list'"
               class="subheader">
    <ion-title>{{ price ? 'Adding a ' + (price | currency) + ' Gift Card' : 'Adding a custom Gift Card'}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <div class="gift-card-modal">
    <div class="gift-card-modal__list"
         *ngIf="view === 'list'">
      <p>Please select an amount</p>
      <div class="gift-card-modal__list__items">
        <ion-card *ngFor="let amount of [5,10,15,20,30,50,75,100]"
                  color="whitesmoke"
                  class="gift-card-modal__list__item"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onSelectGiftCard(amount)">
          <ion-card-header>
            <ion-card-title>{{amount | currency}}</ion-card-title>
          </ion-card-header>
        </ion-card>
        <ion-card color="whitesmoke"
                  class="gift-card-modal__list__item"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onSelectGiftCard()">
          <ion-card-header>
            <ion-card-title>Custom</ion-card-title>
          </ion-card-header>
        </ion-card>
      </div>
    </div>
    <div class="gift-card-modal__custom-price"
         *ngIf="view === 'custom-price'">
      <p>Enter a custom amount</p>
      <pos-numeric-keyboard [buttons]="[]"
                            (onValueChange)="amount = $event"
                            (submitEvent)="onConfirmCustomAmount()"></pos-numeric-keyboard>
    </div>
    <div class="gift-card-modal__scan"
         *ngIf="view === 'scan'">
      <p>Please scan or swipe the gift card</p>

      <div>
        <div>
          <img src="assets/icon/gift_card_scan.svg">
          <label>Scan</label>
        </div>
        <label>or</label>
        <div>
          <img src="assets/icon/gift_card_swipe.svg">
          <label>Swipe</label>
        </div>
      </div>
    </div>
    <div class="gift-card-modal__manual"
         *ngIf="view === 'manual'">
      <p>Enter a gift card number</p>
      <ion-input type="text"
                 placeholder="Gift Card Number"
                 [(ngModel)]="gift_card_code"></ion-input>
    </div>
    <div class="gift-card-modal__summary"
         *ngIf="view === 'summary'">
      <h1>Gift card number</h1>
      <h2>#{{ gift_card_code }}</h2>
    </div>
  </div>
</ion-content>
<ion-footer *ngIf="view !== 'list'">
  <ion-toolbar mode="md"
               color="light">
    <ion-buttons slot="end">
      <ion-button *ngIf="view === 'custom-price'"
                  mode="md"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onConfirmCustomAmount()">CONFIRM CUSTOM AMOUNT</ion-button>
      <ion-button *ngIf="view === 'scan'"
                  mode="md"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onManualGiftCardEntry()">MANUAL ENTRY</ion-button>
      <ion-button *ngIf="view === 'manual'"
                  mode="md"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onConfirmGiftCardNumber()">CONFIRM GIFT CARD NUMBER</ion-button>
      <ion-button *ngIf="view === 'summary'"
                  mode="md"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onAddToTicket()">ADD TO TICKET</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>